<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row" *ngIf="!passwordReset">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <h1 class="mt-5">Change Password</h1>
        </div>
      </div>
      <div class="row" *ngIf="!passwordReset">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <form class="standard-form">
            <mat-form-field>
              <mat-label>New Password</mat-label>
              <input
                matInput
                name="password"
                [(ngModel)]="password"
                type="password"
              /> </mat-form-field
            ><br />
            <mat-form-field>
              <mat-label>Confirm Password</mat-label>
              <input
                matInput
                name="confirmPassword"
                type="password"
                [(ngModel)]="confirmPassword"
              />
            </mat-form-field>
          </form>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row" *ngIf="!passwordReset">
        <div class="col-md-12">
          <span style="color: red">{{ errorMessage }}</span>
        </div>
      </div>
      <div class="row" *ngIf="!passwordReset">
        <div class="col-md-6"></div>
        <div class="col-md-4">
          <button mat-raised-button class="piButton" (click)="changePassword()">
            Change Password
          </button>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row" *ngIf="passwordReset">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          Your password has been sucessfully changed. Use the login link above
          to login with your new password.
        </div>
        <div class="col-md-2"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
